import Landings from "components/layouts/landings";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import CartLayout from "~/components/layouts/cart";
import LayoutNew from "~/components/layouts/mainNew";
import { SiteTypes } from "~/redux/reducers/paramsReducer";
import { safeSessionStorage } from "~/utils/safeStorage";

import Baltex from "./baltex";
import Layout from "./main";

export default function LayoutWrapper({
  host,
  children,
  scripts,
  isIndex = true,
  isMain = false,
  isCart = false,
}: any) {
  const { siteType } = useSelector((state: any) => state.params);

  useEffect(() => {
    if (typeof window !== "undefined") {
      safeSessionStorage.setItem("previosUrl", window.location?.href);
    }
  }, []);

  return (
    <>
      {siteType === SiteTypes.Baltex && (
        <Baltex isIndex={isIndex} scripts={scripts}>
          {children}

          <span
            dangerouslySetInnerHTML={{
              __html: `
                 <style>
                    :root {
                        --font: 'Gilroy';
                        --main-theme: #09080A;
                        --main-theme-2: #09080A;
                        --link-color: #0FB1B1;
                        --main-theme-hover: #333;
                        --main-theme-text: #fff;
                        --main-theme-border-radius: 0px;
                        --main-theme-back: #F2F2F2;
                    }
                </style>
                `,
            }}
          />
        </Baltex>
      )}
      {siteType === SiteTypes.Landing && (
        <Landings isMain={isMain} isIndex={isIndex} isLanding>
          {children}

          <span
            dangerouslySetInnerHTML={{
              __html: `
                 <style>
                    :root {
                        --font: 'Manrope';
                        --main-theme: #FADE74;
                        --main-theme-2: #09080A;
                        --link-color: #09080A;
                        --main-theme-hover: #ffd842;
                        --main-theme-text: #09080A;
                        --main-theme-border-radius: 4px;
                        --main-theme-back: #F2F2F2;
                    }
                </style>
                `,
            }}
          />
        </Landings>
      )}
      {siteType === SiteTypes.Farkop && (
        <>
          {isCart && (
            <CartLayout host={host} isIndex={isIndex} scripts={scripts}>
              {children}

              <span
                dangerouslySetInnerHTML={{
                  __html: `
                <style>
                    :root {
                        --font: 'Golos Text';
                        --font-color: #384250;
                        --font-weight: 400;
                        --main-theme: #1247a5;
                        --main-theme-2: #1247a5;
                        --link-color: #1247a5;
                        --main-theme-hover: #0634B0;
                        --main-theme-text: #fff;
                        --main-theme-border-radius: 4px;
                        --main-theme-back: #fff;
                        --swiper-theme-color: #1247a5;
                        --swiper-navigation-size: 30px
                    }
                </style>
                `,
                }}
              />
            </CartLayout>
          )}
          {false && !isCart && (
            <LayoutNew isMain={isMain} host={host} isIndex={isIndex}>
              {children}

              <span
                dangerouslySetInnerHTML={{
                  __html: `
                <style>
                    :root {
                        --font: 'Golos Text';
                         --font-color: #384250;
                        --font-weight: 400;
                        --main-theme: #1247a5;
                        --main-theme-2: #1247a5;
                        --link-color: #1247a5;
                        --main-theme-hover: #0634B0;
                        --main-theme-text: #fff;
                        --main-theme-border-radius: 4px;
                        --main-theme-back: #fff;
                        --swiper-theme-color: #1247a5;
                        --swiper-navigation-size: 30px
                    }
                </style>
                `,
                }}
              />
            </LayoutNew>
          )}
          {true && !isCart && (
            <Layout host={host} isIndex={isIndex} scripts={scripts}>
              {children}

              <span
                dangerouslySetInnerHTML={{
                  __html: `
                <style>
                    :root {
                        --font: 'Golos Text';
                         --font-color: #384250;
                        --font-weight: 400;
                        --main-theme: #1247a5;
                        --main-theme-2: #1247a5;
                        --link-color: #1247a5;
                        --main-theme-hover: #0634B0;
                        --main-theme-text: #fff;
                        --main-theme-border-radius: 4px;
                        --main-theme-back: #fff;
                        --swiper-theme-color: #1247a5;
                        --swiper-navigation-size: 30px
                    }
                </style>
                `,
                }}
              />
            </Layout>
          )}
        </>
      )}
    </>
  );
}
